import styles from "./Tabs.module.scss";

import { ComponentType, useState } from "react";
import Tab from "./Tab";

interface TabProps {
  id: string;
  label: string;
  content: React.ReactNode;
  Icon?: ComponentType;
  onTabChange?: (id: string) => void;
}

interface TabsProps {
  tabs: TabProps[];
  defaultActiveTabId?: string;
  tabClassName?: string;
  tabsListClassName?: string;
  activeTabClassName?: string;
  tabContentClassName?: string;
}

export const Tabs = ({
  tabs,
  defaultActiveTabId,
  tabClassName = "",
  tabsListClassName = "",
  activeTabClassName = "",
  tabContentClassName = "",
}: TabsProps) => {
  const [activeTab, setActiveTab] = useState(defaultActiveTabId || tabs[0]?.id);

  const handleTabClick = (tab: {
    id: string;
    onTabChange?: (id: string) => void;
  }) => {
    setActiveTab(tab.id);
    if (tab.onTabChange) {
      tab.onTabChange(tab.id);
    }
  };

  return (
    <div className={`${styles.tabsPanel}`}>
      <div className={`${styles.tabList} ${tabsListClassName}`}>
        {tabs.map((tab) => (
          <Tab
            key={tab.id}
            label={tab.label}
            Icon={tab.Icon}
            isActive={activeTab === tab.id}
            onClick={() => handleTabClick(tab)}
            tabClassName={tabClassName}
            activeTabClassName={activeTabClassName}
          />
        ))}
      </div>
      <div className={tabContentClassName}>
        {tabs.find((tab) => tab.id === activeTab)?.content}
      </div>
    </div>
  );
};
